import { Icon } from "../Icon"

interface MenuIconProps {
  size?: number
  className?: string
}

export const MenuIcon = ({ size = 18, className }: MenuIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 20 20" className={className}>
      <path
        d="M1.75 4H18.2452M1.75 16H10.25M1.75239 10H18.2476"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
